import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const testHandlePrintAsPDF = async (cardRef, name) => {
  if (cardRef.current === null) return;

  try {
    const canvas = await html2canvas(cardRef.current, {
    scale: 2,
      // scale: 1.5,
      useCORS: true,
    });

    // const dataUrl = canvas.toDataURL('image/png');
    // const dataUrl = canvas.toDataURL('image/jpeg', 0.85); // JPEG with quality
    const dataUrl = canvas.toDataURL('image/jpeg', 1); // JPEG with quality

    // const pdfWidthInInches = 3.74;
    // const pdfHeightInInches = 4.5;  
    // const pdfWidthInPoints = pdfWidthInInches * 72;
    // const pdfHeightInPoints = pdfHeightInInches * 72;

    // const pdfWidthPx = 560;
    const pdfWidthPx = 1600;
    // const pdfHeightPx = 434;
    const pdfHeightPx = 1240;
    const pdfWidthInPoints = (pdfWidthPx / 96) * 72;
    const pdfHeightInPoints = (pdfHeightPx / 96) * 72;

    // const pdf = new jsPDF('p', 'pt', [pdfWidthInPoints, pdfHeightInPoints]);
    const pdf = new jsPDF('l', 'pt', [pdfWidthInPoints, pdfHeightInPoints]);
    const imgWidth = pdfWidthInPoints;
    const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

    // pdf.addImage(dataUrl, 'PNG', 0, 0, imgWidth, imgHeight);
    // pdf.addImage(dataUrl, 'PNG', 0, 0, pdfWidthInPoints, pdfHeightInPoints);
    pdf.addImage(dataUrl, 'JPEG', 0, 0, pdfWidthInPoints, pdfHeightInPoints);

	// PREVIEW PDF IN NEW TAB
    const pdfBlob = pdf.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl);

	// OR DOWNLOAD PDF
	// pdf.save(`${name}-${+new Date()}-kiyg-esports-certificate.pdf`);
  } catch (error) {
    console.error('Failed to export as PDF:', error);
  }
};